import React from 'react'
import Goals from './Goals'
import Team from './Team'

export default function About() {
  return (
    <>
    <Goals />
    </>
  )
}
